define('shared/initializer/form/adapters/mixins/LeadConfigurable',[
    'shared/page/runmode'
],
function (
    getRunMode
) {
    'use strict';

    function Ctor() { }

    var p = Ctor.prototype;

    p.doPageLoad = function() {
        var me = this;
        return getRunMode()
            .then(function(runmode){
                if (runmode === 'author') {
                    if (
                        me.configs && 
                        me.configs.redirectable && 
                        me.configs.redirectable.url
                    ) {
                       me.configs.redirectable.url += '.html?wcmmode=disabled';
                    }
                }
            });
    };

    return Ctor;
});

